(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-home-slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';
  
  // Set mobile heights
  function setMobileHeights() {
    var bannerItems = document.querySelectorAll('.custom-hero-banner-item');
    
    bannerItems.forEach(function(item) {
      var mobileHeight = item.getAttribute('data-mobile-height');
      
      if (window.innerWidth <= 768 && mobileHeight) {
        item.style.height = mobileHeight + 'px';
      }
    });
  }
  
  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setMobileHeights);
  } else {
    setMobileHeights();
  }
  
  // Re-check on resize
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setMobileHeights, 250);
  });
  
  // Re-initialize on Shopify section events
  document.addEventListener('shopify:section:load', setMobileHeights);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  // Is the element actually visible (not the hidden desktop/mobile variant)?
  function isVisible(el) {
    return !!(el && el.offsetParent !== null);
  }

  // Play the video on the current slide; pause/reset every other (and clones).
  function syncSlideshow(slideshow) {
    if (!slideshow) return;
    var videos = slideshow.querySelectorAll('video[data-cc-slide-video]');
    if (!videos.length) return;

    var current =
      slideshow.querySelector('.slick-current:not(.slick-cloned)') ||
      slideshow.querySelector('.slick-current') ||
      slideshow;

    Array.prototype.forEach.call(videos, function (video) {
      var shouldPlay =
        current.contains(video) &&
        isVisible(video) &&
        video.getAttribute('data-autoplay') === 'true' &&
        !prefersReducedMotion;

      if (shouldPlay) {
        video.muted = true; // required for programmatic autoplay
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {/* autoplay blocked: poster stays */});
        }
      } else if (!video.paused) {
        try { video.pause(); } catch (e) {}
      }
    });
  }

  function bind(scope) {
    var $ = window.jQuery || window.$;
    var root = scope && scope.querySelectorAll ? scope : document;
    var slideshows = root.querySelectorAll('.slideshow');

    Array.prototype.forEach.call(slideshows, function (slideshow) {
      if (!slideshow.querySelector('video[data-cc-slide-video]')) return;

      // Slick fires custom (jQuery) events — only catchable via jQuery handlers.
      if ($) {
        $(slideshow)
          .off('afterChange.ccSlideVideo init.ccSlideVideo')
          .on('afterChange.ccSlideVideo init.ccSlideVideo', function () {
            syncSlideshow(slideshow);
          });
      }
      // Slick may already be initialised by the time we bind — sync now too.
      syncSlideshow(slideshow);
    });
  }

  function boot() { bind(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Desktop/mobile variant can swap on resize -> re-evaluate which video plays.
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(boot, 250);
  });

  // Theme editor: re-bind on section load and react to block selection.
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
  document.addEventListener('shopify:section:select', function (e) { bind(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    bind(e.target.closest('.section-slideshow') || document);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    bind(e.target.closest('.section-slideshow') || document);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
